import { render, staticRenderFns } from "./sliderAndInput.vue?vue&type=template&id=be24d674&scoped=true&"
import script from "./sliderAndInput.vue?vue&type=script&lang=js&"
export * from "./sliderAndInput.vue?vue&type=script&lang=js&"
import style0 from "./sliderAndInput.vue?vue&type=style&index=0&id=be24d674&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be24d674",
  null
  
)

export default component.exports